import useArchive from '@hooks/useArchive'
import useTitle from '@hooks/useTitle'
import useSalonController from '@jury/api/useSalonController'
import MainContainer from '@blocks/MainContainer'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import SalonArchiveComponent from './components/SalonArchiveComponent'

export default function CurrentPage() {
    useTitle("Salons")
    useMainTemplate({ category: "jury:salons" })

    const controller = useSalonController()
    const salons = controller.index.use("jury:current")

    const archive = useArchive(salons.data)
    archive.useComponent(SalonArchiveComponent)
    archive.useEmpty({
        heading: "Salons where you can vote will be displayed here",
        description: "You don't have salons in the list yet."
    })

    return (
        <MainContainer heading="Salons" box={false}>
            {archive.element}
        </MainContainer>
    )
}